var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Economy",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m45.189 55.666h-26.378c-3.571 0-6.477-2.906-6.477-6.478v-15.711c0-3.571 2.906-6.477 6.477-6.477h26.379c3.571 0 6.477 2.905 6.477 6.477v15.712c0 3.571-2.906 6.477-6.478 6.477zm-26.378-26.666c-2.469 0-4.477 2.008-4.477 4.477v15.712c0 2.469 2.008 4.478 4.477 4.478h26.379c2.469 0 4.477-2.009 4.477-4.478v-15.712c0-2.469-2.008-4.477-4.477-4.477z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40 29c-.552 0-1-.447-1-1v-10.667c0-3.859-3.14-7-7-7s-7 3.141-7 7v10.667c0 .553-.448 1-1 1s-1-.447-1-1v-10.667c0-4.963 4.038-9 9-9s9 4.037 9 9v10.667c0 .553-.448 1-1 1z",
    fill: "rgb(0,0,0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m38.087 41.333c-.07-2.753-4.105-2.752-4.174 0 .07 2.753 4.105 2.752 4.174 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46.087 41.333c-.07-2.753-4.105-2.752-4.174 0 .07 2.753 4.105 2.752 4.174 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.087 41.333c-.07-2.753-4.105-2.752-4.174 0 .07 2.753 4.105 2.752 4.174 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.087 41.333c-.07-2.753-4.105-2.752-4.174 0 .07 2.753 4.105 2.752 4.174 0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.d55da5a5ecf484415ceeee6c867aba90.svg";
export { ForwardRef as ReactComponent };